import styled, {css} from 'styled-components';
import {device} from '../../../styled/device';
import DatesAndGuestsBox from '../DatesAndGuestsBox';

export const GuestList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 210px;
  overflow: auto;
  margin-bottom: 10px;
  padding-right: 40px;

  ::-webkit-scrollbar {
    width: 10px;
    border-radius: 14px;
    background-color: #f2f2f8;
  }

  ::-webkit-scrollbar-track {
    background: #f2f2f8;
    background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 14px;
    background: #385cf8;
    box-shadow: 0 3px 4px #00020334;
  }
`;

export const GuestLine = styled.div<{isComplete?: boolean}>`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 0;

  :first-child {
    padding-top: 0;
  }

  :last-child {
    padding-bottom: 0;
  }
`;

export const GuestNumber = styled.div<{isComplete?: boolean}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  background-color: ${({isComplete}) => (isComplete ? '#32D7BE' : '#9696b9')};
`;

export const GuestName = styled.div<{isComplete?: boolean}>`
  font-size: 16px;
  margin-left: 10px;
  margin-right: auto;
  color: ${({isComplete}) => (isComplete ? '#9696B9' : '#353945')};
  font-weight: ${({isComplete}) => (isComplete ? '600' : '500')};
`;

export const DeleteButton = styled.span<{disabled?: boolean}>`
  cursor: pointer;

  ${props =>
    props.disabled &&
    css`
      opacity: 0.6;
    `}

  &:hover {
    opacity: 0.8;
  }
`;

export const EditButton = styled.span`
  cursor: pointer;
`;

export const DatesAndGuestsBoxStyled = styled(DatesAndGuestsBox)`
  background-color: #e6e8ec;

  & .title {
    font-size: 16px;
  }
  & .value {
    font-size: 18px;
  }

  @media (max-width: ${device.mobileXL}) {
    border-radius: 0;
  }
`;

export const NewGuestButton = styled.span`
  border-top: 1px solid #e6e8ec;
  padding-top: 15px;
  display: flex;
  align-items: center;
  grid-gap: 5px;
  cursor: pointer;
  color: #353945;
  margin-left: 5px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1;

  &:hover {
    opacity: 0.8;
  }
`;

export const DeleteGuestModal = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 400px;
  padding-top: 22px;

  .delete-guest-modal_title {
    font-size: 30px;
    font-family: Poppins-Regular, sans-serif;
    font-weight: 400;
    color: #23262f;
  }

  .delete-guest-modal_text {
    display: flex;
    padding: 15px 0 40px 0;
    font-family: Poppins-Regular, sans-serif;
    font-size: 14px;
    color: #777e90;
  }
  .delete-guest-modal_buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
    row-gap: 25px;
    column-gap: 24px;
    width: 100%;
  }
`;
